module.exports = __webpack_public_path__ + "static/media/icon-mensch-im-zentrum.8c6d475b.svg";